const mutations = {
  ['SET_PEDING_APPROVAL']: (state, payload) => {
    state.pendingApproval = payload
  },
  ['SET_PEDING_APPROVAL_PAGINATION']: (state, payload) => {
    state.pendingApprovalPagination = payload
  },
  ['CLEAR_LICENSES_STATE']: (state) => {
    state.pendingApproval = []
    state.pendingApprovalPagination = []
  }
}

export default mutations